module.exports = __webpack_public_path__ + "static/img/mechanism-of-action.c2aa96b0.png";